export const SectionOptions = Object.freeze({
  Notification: 10, // Notificaciones
});

export const SectionsNames = Object.freeze({
  [SectionOptions.Notification]: "Notificaciones",
  [SectionOptions.Security]: "Seguridad y Permisos",
  [SectionOptions.MyAccount]: "Mi cuenta",
});

export const ActionPlanStrategy = {
  Personalized: 1,
  Upgrade: 2,
};
export const ActionPlanStrategyText = {
  [ActionPlanStrategy.Personalized]: 'Personalizar',
  [ActionPlanStrategy.Upgrade]: 'Upgrade',
};
export const ActionPlanStrategyColor = {
  [ActionPlanStrategy.Personalized]: 'cyan',
  [ActionPlanStrategy.Upgrade]: 'purple',
};